import { render, staticRenderFns } from "./CompareFarmsOwnersController.vue?vue&type=template&id=fafa26fa&"
import script from "./CompareFarmsOwnersController.vue?vue&type=script&lang=ts&"
export * from "./CompareFarmsOwnersController.vue?vue&type=script&lang=ts&"
import style0 from "./compare-farms-owners-controller.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports